import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
export const GeneralTableBooleanColumn = cell => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-body font-weight-bold"
  }, cell ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheck
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};